const { VUE_APP_API_BASE_URL: API_BASE_URL } = process.env;
const { VUE_APP_LARAVEL_CLIENT_ID: LARAVEL_CLIENT_ID } = process.env;
const { BASE_URL } = process.env;

/**
 * Generates a high-entropy random string (Code Verifier)
 * compliant with RFC 7636.
 */
const generateVerifier = (): string => {
    const array = new Uint8Array(32);
    // Fill the array with cryptographically strong random values
    window.crypto.getRandomValues(array);
    return base64UrlEncode(array);
};

/**
 * Helper function to encode a Uint8Array to a Base64-URL string.
 * This format replaces +, / with -, _ and removes padding (=).
 */
const base64UrlEncode = (byteArray: Uint8Array): string => {
    const binString = Array.from(byteArray, (byte) => String.fromCharCode(byte)).join("");
    return btoa(binString)
        .replace(/\+/g, "-")
        .replace(/\//g, "_")
        .replace(/=/g, "");
};

/**
 * Creates a Code Challenge from a Verifier using SHA-256 hashing.
 */
const generateChallenge = async (verifier: string): Promise<string> => {
    const encoder = new TextEncoder();
    const data = encoder.encode(verifier);
    
    // Calculate the SHA-256 hash using the Web Crypto API
    const hash = await window.crypto.subtle.digest('SHA-256', data);
    
    return base64UrlEncode(new Uint8Array(hash));
};

export const getOAuthCallbackUrl = (): string => {
    const basePath = BASE_URL && BASE_URL !== "/" ? BASE_URL.replace(/\/+$/, "") : "";
    return `${window.location.origin}${basePath}/#/auth/callback`;
};

/**
 * Initiates the PKCE Authorization flow by generating codes 
 * and redirecting the browser to the Laravel Passport authorization server.
 */
export const redirectToLogin = async (): Promise<void> => {
    const verifier = generateVerifier();
    
    // Store the verifier in localStorage to use it later during the token exchange
    localStorage.setItem("creditor_portal_code_verifier", verifier);

    const challenge = await generateChallenge(verifier);

    const params = new URLSearchParams({
        client_id: LARAVEL_CLIENT_ID,
        redirect_uri: getOAuthCallbackUrl(),
        response_type: "code",
        scope: "", // Add scopes if required, e.g., 'view-user'
        code_challenge: challenge,
        code_challenge_method: "S256",
    });

    window.location.href = `${API_BASE_URL}/oauth/authorize?${params.toString()}`;
};